import { createFolderSelectors } from './folderSelectorsFactory';
import { AppState } from '../types/store';
import { STASH_FOLDER_DEVIATIONS_STREAM, STASH_SUBFOLDERS_STREAM } from '../../constants';

export const {
  getFolderDeviations,
  getHasDeviations,
  getSubfolders,
  getVisibleSubfolders,
  getHasSubfolders,
  getHasMoreSubfolders,
} = createFolderSelectors(
  STASH_FOLDER_DEVIATIONS_STREAM.streamId,
  STASH_SUBFOLDERS_STREAM.streamId
);

export function getStashFolder(state: AppState) {
  return state.stash?.folder;
}

export function getIsVisitorView(state: AppState) {
  return !!state.stash?.isVisitorView;
}
